import { h } from 'preact';

export default (props) => {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="black" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="X" {...props}>
			<path d="M13.869 11.031L20.877 2.667H19.216L13.132 9.93L8.272 2.667H2.667L10.016 13.65L2.667 22.421H4.327L10.753 14.751L15.885 22.421H21.49L13.869 11.031H13.869ZM11.595 13.746L10.85 12.653L4.926 3.95H7.476L12.257 10.973L13.002 12.067L19.217 21.196H16.666L11.595 13.747V13.746Z" />
		</svg>
	);
};